// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SocialActionsMenu-cls1___3ce890f19957100357e{/*!*/}.SocialActionsMenu-cls2__dbbc6a3f8470af37a640{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SocialActionsMenu-cls1___3ce890f19957100357e",
	"cls2": "SocialActionsMenu-cls2__dbbc6a3f8470af37a640 SocialActionsMenu-cls1___3ce890f19957100357e"
};
export default ___CSS_LOADER_EXPORT___;
